module.exports = __webpack_public_path__ + "static/media/bitmap-m-a-2@1x.ba215fb2.png";